import { render, staticRenderFns } from "./OrganizationRequestFilters.vue?vue&type=template&id=950922b4&"
import script from "./OrganizationRequestFilters.vue?vue&type=script&lang=js&"
export * from "./OrganizationRequestFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports